// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/plex_data.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import type { PlexCoreConfig } from "./plex_core_config_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_plex_core_config } from "./plex_core_config_pb";
import type { PlexMetadata } from "./plex_metadata_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_plex_metadata } from "./plex_metadata_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/plex_data.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_plex_data: GenFile = /*@__PURE__*/
  fileDesc("CjdxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvcGxleF9kYXRhLnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEiswIKCFBsZXhEYXRhEiAKAmlkGAEgASgJQg+CtRgLEgdwbGV4X2lkIAFIAIgBARIfCghhc3NheV9pZBgCIAEoCUIIgrUYBBgBIAFIAYgBARJWChBwbGV4X2NvcmVfY29uZmlnGAMgASgLMjcucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLlBsZXhDb3JlQ29uZmlnSAKIAQESUQoNcGxleF9tZXRhZGF0YRgEIAEoCzI1LnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5QbGV4TWV0YWRhdGFIA4gBAUIFCgNfaWRCCwoJX2Fzc2F5X2lkQhMKEV9wbGV4X2NvcmVfY29uZmlnQhAKDl9wbGV4X21ldGFkYXRhYgZwcm90bzM", [file_quanterix_common_extensions_v1_field_options, file_quanterix_simoa_one_analysis_app_api_v1_plex_core_config, file_quanterix_simoa_one_analysis_app_api_v1_plex_metadata]);

/**
 * Represents the top-level container for information that describes an
 * individual plex within an assay, including metadata and configuration
 * parameters required for analysis of the target analyte.
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.PlexData
 */
export type PlexData = Message<"quanterix.simoa_one.analysis_app_api.v1.PlexData"> & {
  /**
   * Unique (UUID) identifier of this plex
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * Unique identifier (UUID) of the parent assay associated with this plex
   *
   * @remarks
   * For backward-compatibility with existing "Protocol" and "Definition"
   * assay messages, this field should be mapped to `*_protocol_id`, however,
   * the concepts of assay "protocol" and "definition" are not applicable
   * to this message and is children.
   *
   * @generated from field: optional string assay_id = 2;
   */
  assayId?: string;

  /**
   * Contains core plex configuration information for use in analysis
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.PlexCoreConfig plex_core_config = 3;
   */
  plexCoreConfig?: PlexCoreConfig;

  /**
   * Contains supplemental information about the plex
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.PlexMetadata plex_metadata = 4;
   */
  plexMetadata?: PlexMetadata;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.PlexData.
 * Use `create(PlexDataSchema)` to create a new message.
 */
export const PlexDataSchema: GenMessage<PlexData> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_plex_data, 0);

